import { IncomeCalcLocation } from '../models/IncomeCalcLocation.model'

export const findExactCityMatch = (query: string, locations: IncomeCalcLocation[]): string | null => {
  const trimmed = query.trim()
  if (!trimmed) {
    return null
  }

  const match = locations.find((location) => location.city.toLowerCase() === trimmed.toLowerCase())
  return match?.city ?? null
}

export const syncCityFieldsWithLocations = (
  cityQuery: string,
  selectedCity: string,
  locations: IncomeCalcLocation[],
): { cityQuery: string; selectedCity: string } => {
  const city = selectedCity || cityQuery.trim()
  if (!city) {
    return { cityQuery, selectedCity }
  }

  const match = findExactCityMatch(city, locations)
  if (match) {
    return { cityQuery: match, selectedCity: match }
  }

  return { cityQuery: '', selectedCity: '' }
}

export const resolveCityFromQuery = (query: string, locations: IncomeCalcLocation[]): string | null => {
  const exactMatch = findExactCityMatch(query, locations)
  if (exactMatch) {
    return exactMatch
  }

  const trimmed = query.trim().toLowerCase()
  if (!trimmed) {
    return null
  }

  const prefixMatches = locations.filter((location) => location.city.toLowerCase().startsWith(trimmed))
  if (prefixMatches.length === 1) {
    return prefixMatches[0].city
  }

  return null
}
